import React, { useEffect, useState, useMemo } from "react";
import { collection, getDocs } from "firebase/firestore";
// import { collection, getDocs, query, orderBy } from "firebase/firestore";
import useSortedItems from "../hooks/useSortedItems";
import Modal from "../component/Modal";
import { db } from "../firebase-config";
import { superbadgeMap } from "../assets/certImages/superbadgeImages";
import { SELECT_OPTIONS } from "../config/selectOptions";
import { SORT_OPTIONS } from "../config/sortOptions";

function Superbadges() {
  const [superbadges, setSuperbadges] = useState([]);
  const [sortMode, setSortMode] = useState("completed-reverse"); // default sort mode
  const [selectedTag, setSelectedTag] = useState("all");
  const [selectedBadge, setSelectedBadge] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const sortedSuperbadges = useSortedItems(superbadges, sortMode);

  const filteredSuperbadges = useMemo(() => {
    if (selectedTag ==="all") return sortedSuperbadges;
    return sortedSuperbadges.filter(item => 
      item.tags?.includes(selectedTag)
    )
  }, [sortedSuperbadges, selectedTag]);

  const openModal = (superbadge) => {
    setSelectedBadge(superbadge);
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setSelectedBadge(null);
    setIsModalOpen(false);
  }

  useEffect(() => {
    const fetchSuperbadges = async () => {
      try {
        const superbadgesRef = collection(db, "superbadges");
        // const q = query(superbadgesRef, orderBy("completed", "desc"));
        // const snapshot = await getDocs(q);
        const snapshot = await getDocs(superbadgesRef);

        // const superbadgesData = snapshot.docs.map((doc) => ({
        //   id: doc.id,
        //   ...doc.data(),
        // }));
        
        const superbadgesData = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            ... data,
            completedDate: data.completed?.toDate
              ? data.completed.toDate()
              : data.completed || null,
          };
        });

        setSuperbadges(superbadgesData);
      } catch (err) {
        console.error("Error fetching superbadges:", err);
      }
    };

    fetchSuperbadges();
  }, []);

  return (
    <div className="superbadgeGrid">
      <h2>Superbadges</h2>
      <div className="superbadgeSortFilterSelect">
        <div style={{ marginRight: "15px"}}>
          <label>Sort by: </label>
          <select
            value={sortMode}
            onChange={(e) => setSortMode(e.target.value)}
          >
            {SORT_OPTIONS.map(srt => (
              <option key={srt.value} value={srt.value}>
                {srt.label}
              </option>
            ))}
            {/* <option value="completed-reverse">Completed (Newest First)</option>
            <option value="completed">Completed (Oldest First)</option>
            <option value="name">Name (A-Z)</option>
            <option value="name-reverse">Name (Z-A)</option> */}
          </select>
        </div>
        <div style={{ marginLeft: "15px"}}>
          <label>Filter by tag: </label>
          <select
            value={selectedTag}
            onChange={(e) => setSelectedTag(e.target.value)}
          >
            {SELECT_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
            {/* <option value="all">All</option>
            <option value="businessAdministration">Business Administration</option>
            <option value="userManagement">User Management</option>
            <option value="salesCloud">Sales Cloud</option>
            <option value="dataImporting">Data Importing</option>
            <option value="flow">Flow</option>
            <option value="lightning">Lightning</option>
            <option value="security">Security</option>
            <option value="approvalProcess">Approval Process</option>
            <option value="serviceCloud">Service Cloud</option>
            <option value="reporting">Reporting</option>
            <option value="agentforce">Agentforce</option>
            <option value="AI">AI</option>
            <option value="declarativeAutomation">Declarative Automation</option>
            <option value="processes">Processes</option>
            <option value="salesforcePlatform">Salesforce Platform</option>
            <option value="legacy">Legacy</option> */}
          </select>
        </div>
      </div>

      <div className="superbadgeContainer">
        {/* {superbadges.length === 0 ? ( */}
        {/* {sortedSuperbadges.length === 0 ? ( */}
        {filteredSuperbadges.length === 0 ? (
        <p>No superbadges found.</p>
      ) : (
        // superbadges.map((superbadge) => (
        // sortedSuperbadges.map((superbadge) => (
        filteredSuperbadges.map((superbadge) => (
          <div
            className="superbadge"
            key={superbadge.id}
            onClick={() => openModal(superbadge)}
          >
            <h2>{superbadge.name}</h2>
            <div className="superbadgeInner">
              <img
                src={superbadgeMap[superbadge.hiddenName] || null}
                alt={superbadge.name}
                className="superbadgeImage"
              />
              <div className="superbadgeDetails">
                <p>
                  {superbadge.description}
                </p>
                <p className="SuperbadgeDetailsCompleted">
                  Completed{" "}
                  {superbadge.completed?.toDate
                      ? superbadge.completed
                          .toDate()
                          .toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          })
                      : "Date unknown"}
                </p>
                <div className="tagRow">
                    {superbadge.tags?.map((tag) => (
                      <span
                        key={tag}
                        className={`tagChip ${selectedTag === tag ? "selected" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          
                          // If clicking the same tag again, reset to "all"
                          if (selectedTag === tag) {
                            setSelectedTag("all")
                          } else {
                            setSelectedTag(tag)
                          }
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                </div>
              </div>
            </div>

          </div>
        ))
      )}
      </div>
        {isModalOpen && (
          <Modal doc={selectedBadge} onClose={closeModal} />
        )}
    </div>
  );
}

export default Superbadges;